import { useEffect } from 'react';

const DEFAULT_IGNORED_SELECTOR =
  'input, textarea, select, [contenteditable="true"]';

export const useBoardDeleteKey = options => {
  const {
    enabled = true,
    hasSelection = false,
    ignoredSelector = DEFAULT_IGNORED_SELECTOR,
    onDelete,
  } = options || {};

  useEffect(() => {
    const handleKeyDown = event => {
      if (!enabled || !hasSelection) {
        return;
      }
      if (event.key !== 'Delete' && event.key !== 'Backspace') {
        return;
      }
      const target = event.target;
      if (target?.closest?.(ignoredSelector)) {
        return;
      }
      event.preventDefault();
      onDelete?.(event);
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [enabled, hasSelection, ignoredSelector, onDelete]);
};
